
import { useState } from "react"
import { Modal, Button } from "react-bootstrap"
import { Tooltip } from "react-tooltip"
import "react-tooltip/dist/react-tooltip.css"
import Swal from "sweetalert2"
import PrescriptionFollowUp from "../Components/PanchkarmaServiceCallerFollowUp.Component"

const Prescription = ({ patientId, patientName, patientGender, setActiveKey }) => {
  // <CHANGE> Updated state management for static data
  const [showDetailModal, setShowDetailModal] = useState(false)
  const [selectedPrescription, setSelectedPrescription] = useState(null)
  const [completedPrescriptions, setCompletedPrescriptions] = useState(new Set())
  const [showFollowup, setShowFollowup] = useState(null)
  const [selectedPrescriptionForFollowup, setSelectedPrescriptionForFollowup] = useState(null)

  // <CHANGE> Static prescription data replacing API calls
  const staticPrescriptions = [
    {
      prescription_id: 1,
      prescribedBy: "Dr. Smith",
      date: "15 Jan 2024",
      diseases: "Hypertension, Diabetes",
      status: "DELIVERED",
      duration: "30 days",
      note: "Take medicines regularly",
      medicines: [
        {
          prescription_medicine_id: 1,
          medicine_name: "Paracetamol",
          dose: "500mg",
          frequency: "Twice daily",
          qty: 30,
          delivered_qty: 28,
          how_to_take: "After meals",
          delivery_status: "DELIVERED",
          is_custom: "No",
        },
        {
          prescription_medicine_id: 2,
          medicine_name: "Amoxicillin",
          dose: "250mg",
          frequency: "Three times daily",
          qty: 21,
          delivered_qty: 21,
          how_to_take: "Before meals",
          delivery_status: "DELIVERED",
          is_custom: "No",
        },
      ],
      prescription_explained: "No",
      prescription_explained_date: null,
      medicine_started: "No",
      medicine_started_date: null,
      receipt_download_link: "https://example.com/receipt1.pdf",
      totals: {
        items_subtotal: 150,
        items_cgst_amount: 13.5,
        items_sgst_amount: 13.5,
        items_igst_amount: 0,
        gst_price: 27,
        igst_price: 0,
      },
    },
  
  ]

  const handleViewClick = (prescription) => {
    setSelectedPrescription(prescription)
    setShowDetailModal(true)
  }

  const handleTrackProgress = (prescription) => {
    if (prescription && prescription.prescription_id) {
      setSelectedPrescriptionForFollowup(prescription)
      setShowFollowup(prescription.prescription_id)
    }
  }

  const handleMarkAsDone = async () => {
    if (!selectedPrescription) return

    const result = await Swal.fire({
      title: "Mark as Complete?",
      text: "This prescription will be marked as completed.",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, mark as done",
    })

    if (result.isConfirmed) {
      setCompletedPrescriptions((prev) => new Set([...prev, selectedPrescription.prescription_id]))
      Swal.fire("Marked!", "The prescription has been marked as completed.", "success")
      setShowDetailModal(false)
    }
  }

  const handleCloseFollowUp = () => {
    setShowFollowup(null)
    setSelectedPrescriptionForFollowup(null)
  }

  return (
    <div className="col-xl-12">
      <div className="card shadow-none">
        <div className="card-body">
          {/* Prescription Cards */}
          {staticPrescriptions.length > 0 ? (
            <div className="row">
              {staticPrescriptions
                .filter((prescription) => !showFollowup || prescription.prescription_id === showFollowup)
                .map((prescription) => (
                  <div className="col-md-4 mb-4" key={prescription.prescription_id}>
                    <div
                      className="card border-0 p-3 rounded"
                      style={{
                        backgroundColor: "white",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <div className="card-body">
                        <p className="fs-5 mb-0">
                          <strong>Karma Prescribed By:</strong> {prescription.prescribedBy}
                        </p>
                        <p className="fs-5 mb-0">
                          <strong>Date:</strong> {prescription.date}
                        </p>
                   
                        <div className="d-flex justify-content-start mt-3">
                   
                        
                          <Button className="btn btn-info btn-sm" onClick={() => handleTrackProgress(prescription)}>
                            Track Progress
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          ) : (
            <div className="text-center py-5">
              <h5 className="text-muted">No prescriptions found</h5>
            </div>
          )}

          {/* Follow-up Section */}
          {showFollowup && selectedPrescriptionForFollowup && (
            <PrescriptionFollowUp
              selectedPrescriptionForFollowup={selectedPrescriptionForFollowup}
              onClose={handleCloseFollowUp}
              patientId={patientId}
              patientName={patientName}
              patientGender={patientGender}
            />
          )}
        </div>
      </div>

   
    </div>
  )
}

export default Prescription;
